'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var Box = require('../../Base/Layouts/Box/Box.js');
var LoadingIndicator_parts = require('./LoadingIndicator.parts.js');

/**
 * 로딩 상태를 표시하는 애니메이션 인디케이터 컴포넌트입니다.
 * 세 개의 점이 순차적으로 페이드 인/아웃되는 애니메이션을 보여줍니다.
 *
 * @param {Object} props - 컴포넌트 프로퍼티
 * @param {boolean} [props.isFixed=false] - true일 경우 position: fixed, false일 경우 position: absolute로 설정됩니다.
 * @param {('sm'|'md'|'lg')} [props.size='md'] - 로딩 인디케이터의 크기를 설정합니다.
 * @param {string} [props.className] - 추가적인 CSS 클래스를 적용할 수 있습니다.
 *
 * @example
 * // 기본 사용
 * <LoadingIndicator />
 *
 * // 고정 위치에 큰 크기로 표시
 * <LoadingIndicator isFixed size="lg" />
 *
 * // 커스텀 클래스 적용
 * <LoadingIndicator className="text-blue-500" />
 */ const LoadingIndicator = ({ isFixed = false, size = 'md', className })=>{
    const { width, height, viewBox, circle, r } = LoadingIndicator_parts.SIZES[size];
    return jsxRuntime.jsx(Box, {
        role: "loading-indicator",
        className: tailwindMerge.twMerge('left-1/2 top-1/2 aspect-square -translate-x-1/2 -translate-y-1/2', isFixed ? 'fixed' : 'absolute', LoadingIndicator_parts.generateBoxSize(size)),
        children: jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            role: "loading-indicator--dots",
            width: width,
            height: height,
            viewBox: viewBox,
            fill: "none",
            className: tailwindMerge.twMerge('text-primary', className),
            children: [
                jsxRuntime.jsx("circle", {
                    cx: circle[0],
                    cy: circle[1],
                    r: r,
                    fill: "currentColor",
                    children: jsxRuntime.jsx("animate", {
                        attributeName: "opacity",
                        values: "1; 1; 0.5; 0.25; 0.25;",
                        dur: "0.9s",
                        repeatCount: "indefinite",
                        begin: "0s"
                    })
                }),
                jsxRuntime.jsx("circle", {
                    cx: circle[1],
                    cy: circle[1],
                    r: r,
                    fill: "currentColor",
                    children: jsxRuntime.jsx("animate", {
                        attributeName: "opacity",
                        values: "1; 1; 0.5; 0.25; 0.25;",
                        dur: "0.9s",
                        repeatCount: "indefinite",
                        begin: "0.3s"
                    })
                }),
                jsxRuntime.jsx("circle", {
                    cx: circle[2],
                    cy: circle[1],
                    r: r,
                    fill: "currentColor",
                    children: jsxRuntime.jsx("animate", {
                        attributeName: "opacity",
                        values: "1; 1; 0.5; 0.25; 0.25;",
                        dur: "0.9s",
                        repeatCount: "indefinite",
                        begin: "0.6s"
                    })
                })
            ]
        })
    });
};

module.exports = LoadingIndicator;
